import React, { Fragment, useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import Editor from '../../libs/QuillEditor';
import HtmlViewer from '../../libs/HtmlViewer';
import { htmlToDelta, deltaToHtml } from '../../libs/QuillConverter';
import { checkIsNull, dateFormat } from '../../libs/Util';

const TopicView = (props) => {
    const editorRef = React.useRef(null);
    const LoginStates = useSelector(state => state.login);
    const [topicView, setTopicView] = useState([]);
    const [subTopic, setSubTopic] = useState([]);
    const [topicSeq, setTopicSeq] = useState(props.state.topicSeq);
    const [writeReply, setWriteReply] = useState(null);
    const [workingTag, setWorkingTag] = useState(props.state.workingTag);
    const [isWriter, setIsWriter] = useState(false);

    useEffect(() => {
        if ((JSON.stringify(topicView) !== JSON.stringify(props.state.topicView) && props.state.topicView !== undefined)
            || (JSON.stringify(subTopic) !== JSON.stringify(props.state.subTopic) && props.state.subTopic !== undefined)) {
            setTopicView(props.state.topicView);
            setSubTopic(props.state.subTopic);
        }
    });
    useEffect(() => {
        if(topicView.length > 0) {
            if(topicView[0].writerUserId === LoginStates.userId)
                setIsWriter(true);
        }
    }, [topicView]);
    const btnClickReply = (workingTag, subTopicSeq) => {
        if (workingTag === 'D') {
            if (window.confirm('삭제하시겠습니까?')) {
                props.fnSubTopicDelete(subTopicSeq);
            }
        } else if (workingTag === 'C') {
            setWriteReply(null);
            setWorkingTag(workingTag);
        } else {
            setWriteReply(renderReply());
            setWorkingTag(workingTag);
        }
    }
    const subTopicSave = () => {
        const content = deltaToHtml(editorRef.current.getContents());
        const subTopicInfo = {
            content: content,
            contentText: editorRef.current.getText(),
            workingTag: workingTag
        };
        props.fnSubTopicSave(subTopicInfo);
        setWorkingTag('A');
        setWriteReply(null);
    }
    const RenderEditor = (props) => {
        return (
            <Editor
                ref={editorRef}
                readOnly={false}
                defaultValue={props.content}
            />
        );
    }
    const TopicItem = (props) => {
        let item = props.item, isAdmin = false, userId = LoginStates.userId, topicContent = [], topicBottom = [];
        if (!props.isAdmin && !props.isEditor && item.authGrade !== '' && userId !== item.writerUserId) {
            isAdmin = true;
        }
        if (props.isLastData) {
            if (workingTag === 'U') {
                topicContent.push(
                    <RenderEditor key={1} content={htmlToDelta(item.content)} />
                );
                topicBottom.push(
                    <div className="bottom">
                        <button className="btn-primary" onClick={subTopicSave}>등록</button>
                        <button className="btn-secondary" onClick={() => btnClickReply('C')}>취소</button>
                    </div>
                );
            } else {
                topicContent.push(
                    <HtmlViewer key={2} data={item.content} />
                );
                if (!checkIsNull(item.subTopicSeq) && item.writerUserId === userId) {
                    topicBottom.push(
                        <div key={'bottom'} className="bottom">
                            <button className="btn-edit" onClick={() => btnClickReply('U')}>수정</button>
                            <button className="btn-delete" onClick={() => btnClickReply('D', item.subTopicSeq)}>삭제</button>
                        </div>
                    );
                }
            }
        } else {
            topicContent.push(
                <HtmlViewer key={3} data={item.content} />
            );
        }
        return (
            <Fragment>
                <div className={workingTag === 'U' ? 'item write-reply' : 'item'}>
                    <div className="top">
                        <div onClick={(e) => props.fnBtnOnPopup(item, e)} className="author">
                            <div className="pf" style={{ backgroundColor: item.colorCode }}>
                                {isAdmin ? 'P' : item.writerFirstInitial}
                            </div>
                            <a className="name" href={() => { }}>
                                {isAdmin ? '관리자' : item.writer}
                            </a>
                        </div>
                        <span className="date">{dateFormat(new Date(item.writeDate))}</span>
                    </div>
                    {item?.fullPath && (
                        <div className='page-link' onClick={() => window.open(item.linkPath, "_blank")}>
                            <div class="page-link-inner">
                                <div class="doc-path-wrap">
                                    <i className='icoKdc20 document'></i>
                                    <div className="path">
                                        {JSON.parse(item.fullPath)?.map((item, index, arr) => (
                                            <React.Fragment key={index}>
                                                <span className="path-doc">{item}</span>
                                                {index < arr.length - 1 && <i className="icoKdc12 next"></i>}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </div>
                                <p className='doc-title'>{item.menuModule}</p>
                                {/*<p className='doc-writer'>작성자 : 김영림</p>*/}
                            </div>
                            <i className='icoKdc24 page-link-arrow'></i>
                        </div>
                    )}
                    <div className="content">
                        {topicContent}
                    </div>
                    {topicBottom}
                </div>
            </Fragment>
        );
    }
    const Topic = () => {
        let view = [];
        if (topicView.length !== 0) {
            view.push(
                <Fragment key={'View1'}>
                    <div className="topic-title-wrap">
                        <div className="topic-title">
                            <div className="ctgr">{topicView[0].catagoryName}</div>
                            <div className="title">
                                <p>{topicView[0].title}</p>
                                {/* {topicView[0].subTopicCount !== 0
                                    ? <div className="topic-tag reply">
                                        피드 {topicView[0].subTopicCount}
                                    </div> : null} */}
                            </div>
                        </div>
                        {isVisibleReplybtn
                            ? <button className="btn-reply-admin btn-primary"
                                onClick={() => btnClickReply('A')}>답변하기</button> : null}
                    </div>
                    <TopicItem item={topicView[0]}
                        isLastData={subTopic.length === 0 ? true : false}
                        fnBtnOnPopup={props.fnBtnOnPopup}
                        isAdmin={props.isAdmin}
                        fnOnChangeMode={props.fnOnChangeMode}
                        currentPage={props.state.currentPage} />
                </Fragment>
            );
        }
        for (let i = 0; i < subTopic.length; i++) {
            view.push(
                <TopicItem key={i} item={subTopic[i]}
                    isLastData={i === subTopic.length - 1 ? true : false}
                    fnBtnOnPopup={props.fnBtnOnPopup}
                    isAdmin={props.isAdmin}
                    fnOnChangeMode={props.fnOnChangeMode}
                    currentPage={props.state.currentPage} />
            );
        }
        return view;
    }
    const renderReply = () => {
        return (
            <div className="item write-reply">
                <div className="top">
                    <div className="author">
                        <div className="pf" style={{ backgroundColor: '' }}>
                            {LoginStates.userId.substr(0, 1).toUpperCase()}
                        </div>
                        <a className="name" href={() => { }}>
                            {LoginStates.userName}
                        </a>
                    </div>
                </div>
                <div className="content edior">
                    <div className="editor-wrap">
                        <div className="editor">
                            <RenderEditor content={''} />
                        </div>
                    </div>
                </div>
                <div className="bottom">
                    <button className="btn-primary" onClick={subTopicSave}>등록</button>
                    <button className="btn-secondary" onClick={btnClickReply('C')}>취소</button>
                </div>
            </div>
        );
    }
    let lastWriterUserId = '', isVisibleReplybtn = false;
    if (topicView.length !== 0) {
        if (writeReply === null) {
            if (subTopic.length === 0) {
                lastWriterUserId = topicView[0].writerUserId;
            } else {
                lastWriterUserId = subTopic[subTopic.length - 1].writerUserId;
            }
            if (lastWriterUserId !== LoginStates.userId) {
                isVisibleReplybtn = true;
            }
        }
    }
    return (
        <div className="qna-wrap">
            <div className="qna-write-wrap">
                <div className="top-wrap">
                    <button className="btn-back-list"
                        onClick={() => props.fnOnChangeMode('topicList', props.state.currentPage)}>
                        <i className="icoKdc40 arrow-w"></i>
                    </button>
                    <h2 className='myinfo-cnts-title'>{props.topicViewTitle}</h2>
                </div>
                <section className="qna-view">
                    <div className="topic-wrap">
                        <Topic key={'topic'} />
                        {workingTag === 'A' ? writeReply : null}
                        {/*<div className='feed'>*/}
                        {/*    <div className='feed-top'>*/}
                        {/*        <i className='icoKdc16 chat'></i>*/}
                        {/*        <span className='feed-count'>2</span>*/}
                        {/*        <span className='feed-count-span'>개의 피드</span>*/}
                        {/*    </div>*/}
                        {/*    <div className='feed-btm'>*/}
                        {/*        <div className='feed-cnts-wrap'>*/}
                        {/*            <span className='name'>관리자</span>*/}

                        {/*            <span className="date">2024-09-30 12:34</span>*/}
                        {/*            <p className='feed-cnts'>안녕하세요. K-Developers 관리자 입니다.*/}

                        {/*                문의하신 내용은 A/S 접수를 통해 답변이 가능할 것으로 보입니다.*/}

                        {/*                해당 게시판에서는 K Developers에서 제공하는 문서 및 매뉴얼의 내용 및 사이트 이용에 관한 문의만 답변 가능하며*/}
                        {/*                개발과 관련된 각 제품군 별 담당팀의 질의 답변 혹은 안내를 원하시는 경우 영림원 A/S 접수를 이용하시기 바랍니다.*/}

                        {/*                A/S 접수 주소</p>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className="btm-btns">
                            <button className="btn-back-list" onClick={() => props.fnOnChangeMode('topicList', props.state.currentPage)}>목록보기</button>
                            {(props.isAdmin || isWriter) && 
                                <div className="btns-wrap">
                                    <button className='btn-modify' onClick={() => props.fnOnChangeMode('topicUpdate', props.currentPage, topicSeq, topicView)}>수정</button>
                                    <button className='btn-delete' onClick={() => props.fnOnChangeMode('topicDelete')}>삭제</button>
                                </div>
                            }
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
export default TopicView;